import script from "./SplitForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitForm.vue?vue&type=script&setup=true&lang=ts"

import "./SplitForm.vue?vue&type=style&index=0&id=46abe55a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46abe55a"]])

export default __exports__